var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"launch-overview-item",class:{ '--link': _vm.link },attrs:{"to":_vm.link}},[(_vm.title)?_c('h4',[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }